import React, { Component } from "react";
import HeaderMenu from '../Components/HeaderMenu'
import Footer from '../Components/Footer/Footer'
import Whitepaperbody from './Whitepaperbody'

const Whitepaper = () => {
  return (
    <div className="">
      <HeaderMenu />
      <Whitepaperbody />
      <Footer />
    </div>
  );
}

export default Whitepaper;
